import { render, staticRenderFns } from "./HelpFeedback.vue?vue&type=template&id=70919129&scoped=true&"
import script from "./HelpFeedback.vue?vue&type=script&lang=js&"
export * from "./HelpFeedback.vue?vue&type=script&lang=js&"
import style0 from "./HelpFeedback.vue?vue&type=style&index=0&id=70919129&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70919129",
  null
  
)

export default component.exports